import whenShoulIGoToPsychiatrist from "./whenShoulIGoToPsychiatrist";
import whenPsychiatristPrescribeMedicinations from "./whenPsychiatristPrescribeMedicinations";
import firstVisitPsychiatry from "./firstVisitPsychiatry";
import adultPsychiatryCost from "./adultPsychiatryCost";
import isReferralRequired from "./isReferralRequired";
import adultPsychiatryTerms from "./adultPsychiatryTerms";

const psychiatryQuestionSet = [
    whenShoulIGoToPsychiatrist,
    whenPsychiatristPrescribeMedicinations,
    firstVisitPsychiatry,
    adultPsychiatryCost,
    isReferralRequired,
    adultPsychiatryTerms,
]

export default psychiatryQuestionSet;